import { useQuery } from "@tanstack/react-query";
import api from "../api";

const useGetSampleFileInfo = (hash: string) => {
  const { isFetched, data } = useQuery({
    queryFn: () => api.getSampleSpectraCoreInfo(hash),
    queryKey: [hash, "fileInfo"],
    select: ({ data: spectraInfo }) => spectraInfo.info.file
  });

  return { isFetched, data };
};

export default useGetSampleFileInfo;
